import React from 'react';
import comm100 from './comm100';
import livehelperchat from './livehelperchat';

interface Props {
  chat: string;
}

function Chat(props: Props) {
  React.useEffect(() => {
    switch (props.chat) {
      case 'comm100':
      case 'tawkto':
        comm100();
        break;
      case 'livehelperchat':
        livehelperchat();
        break;
    }
  }, [props.chat]);

  return null;
}

export default Chat;
